import Glide from '@glidejs/glide'

(function(window, document) {
    'use strict';

    document.querySelectorAll('.glide--image-text').forEach(function(element) {
        new Glide('#' + element.id).mount();
    });

})(window, document, Glide);
